__turbopack_context__.v({
  "frame": "HeaderLogo-module__UKj7qa__frame",
  "graphic": "HeaderLogo-module__UKj7qa__graphic",
  "letter": "HeaderLogo-module__UKj7qa__letter",
  "mark": "HeaderLogo-module__UKj7qa__mark",
  "root": "HeaderLogo-module__UKj7qa__root",
  "sizer": "HeaderLogo-module__UKj7qa__sizer",
});
